import { api } from "@/services";
import { StoriesResponse } from "@/types";
import { useState } from "react";
import { useIsomorphicLayoutEffect } from "../Custom";

function useStoriesContents(): [Response: StoriesResponse, Error: string | null, Loading: boolean] {
  const [Response, setResponse] = useState<StoriesResponse>(null);
  const [Error, setError] = useState<string>(null);
  const [Loading, setLoading] = useState<boolean>(true);

  useIsomorphicLayoutEffect(() => {
    const Controller = new AbortController();
    //
    const MakeRequest = async () => {
      try {
        const resp: { data: StoriesResponse } = await api.get(
          `Contents/GetBySlug?slugs=stories-linglong`,
          {
            signal: Controller.signal
          }
        );
        if (resp.data) {
          setResponse(resp.data);
        } else {
          setError("Nenhum conteúdo encontrado");
        }
      } catch (Err) {
        setError(Err.message);
      } finally {
        setLoading(false);
      }
    };

    MakeRequest();

    return () => Controller.abort();
  }, []);

  return [Response, Error, Loading];
}

export { useStoriesContents };
